import React from "react";
import { useTheme } from "styled-components";
import CustomTooltip from "components/CustomTooltip";

import { Icon } from "@iconify/react";
import * as S from "./styles";

export function RatingStar({
  value = 0,
  disabled = false,
  name = "",
  tooltip = "",
  onClick = () => {},
}) {
  const theme = useTheme();

  const handleRating = (index) => {
    if (disabled) return;
    onClick(index + 1);
  };

  const handleIcon = ({ value, index }) => {
    const icon =
      value >= index + 1 ? "fluent:star-24-filled" : "fluent:star-24-regular";

    return icon;
  };

  return (
    <S.Container>
      <S.ContainerText>
        <CustomTooltip title={tooltip}>
          <div>
            <Icon
              icon="fluent:question-circle-24-filled"
              width="1.5rem"
              height="1.5rem"
              color={theme.colors.black_0}
            />
          </div>
        </CustomTooltip>
        <span>{name}</span>
      </S.ContainerText>
      <S.ContainerStarts>
        {[...Array(5)].map((_, index) => (
          <S.Star
            onClick={() => handleRating(index)}
            key={index}
            clickable={!disabled}
          >
            <Icon
              icon={handleIcon({ index, value })}
              width="1.5rem"
              height="1.5rem"
              color={theme.colors.primary_5}
            />
          </S.Star>
        ))}
      </S.ContainerStarts>
    </S.Container>
  );
}
